module.exports = __webpack_public_path__ + "img/place13.bcad6ec6.jpg";